import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  connect() {}

  click(event) {
    const resource = event.target.dataset.url;
    Rails.ajax({ type: "GET", url: resource });
  }

  select(event) {
    const path = event.target.dataset.url;
    const id = event.target.value;
    const resource = path.replace(/\/id/, `/${id}`);
    Rails.ajax({ type: "GET", url: resource });
  }
}
